export enum LoadingButtonStyles {
  PRIMARY = 'primary',
  DEFAULT = 'default',
  SECONDARY = 'secondary'
}
